module.exports = __webpack_public_path__ + "img/file-question-01.bd1c580e.svg";